import React, {
  createContext,
  useCallback,
  useContext,
  useState,
  useMemo,
  useRef,
  type ReactNode,
} from "react";

export type BranchModalStep = "order-type" | "pickup-branch" | "delivery-map";

export interface BranchModalContextValue {
  isOpen: boolean;
  step: BranchModalStep;
  onCompleteRef: React.MutableRefObject<((payload?: { lat?: number; lon?: number; branchId?: string }) => void) | null>;
  onCloseRef: React.MutableRefObject<(() => void) | null>;
  openBranchModal: (opts?: { step?: BranchModalStep; onComplete?: (payload?: { lat?: number; lon?: number; branchId?: string }) => void; onClose?: () => void }) => void;

  closeBranchModal: () => void;
  goToStep: (step: BranchModalStep) => void;
  goBack: () => void;
 onComplete?: (payload?: { lat?: number; lon?: number; branchId?: string }) => void;
}

const BranchModalContext = createContext<BranchModalContextValue | undefined>(undefined);

export function BranchModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState<BranchModalStep>("order-type");
  const onCompleteRef = useRef<(() => void) | null>(null);
 const onCloseRef = useRef<(() => void) | null>(null);

const openBranchModal = useCallback(
  (opts?: { step?: BranchModalStep; onComplete?: (payload?: { lat?: number; lon?: number; branchId?: string }) => void; onClose?: () => void  }) => {
     onCompleteRef.current = opts?.onComplete ?? null;
     onCloseRef.current = opts?.onClose ?? null;  // 👈
    setStep(opts?.step ?? "order-type");  // 👈 jump to the right step
    setIsOpen(true);
  },
  []
);

  const closeBranchModal = useCallback(() => {
    setIsOpen(false);
    onCloseRef.current?.();
    onCloseRef.current = null;
    onCompleteRef.current = null;
  }, []);

  const goToStep = useCallback((s: BranchModalStep) => setStep(s), []);

  const goBack = useCallback(() => {
    setStep("order-type");
  }, []);

   


  const value = useMemo<BranchModalContextValue>(
    () => ({
      isOpen,
      step,
      onCloseRef,
      onCompleteRef,
      openBranchModal,
      closeBranchModal,
      goToStep,
      goBack,
    }),
    [isOpen, step, openBranchModal, closeBranchModal, goToStep, goBack]
  );

  return (
    <BranchModalContext.Provider value={value}>
      {children}
    </BranchModalContext.Provider>
  );
}

export function useBranchModal() {
  const ctx = useContext(BranchModalContext);
  if (!ctx) throw new Error("useBranchModal must be used within BranchModalProvider");
  return ctx;
}
